export const formatCash = (value: any, maxAbbreviateDigits = 3, precision = 1) => {
  const number = +(value || 0)
  const abbreviateAt = Number(`1e${maxAbbreviateDigits}`)

  if (number < abbreviateAt) return number.toLocaleString()

  const abbreviations = ["K", "M", "B", "T"]
  if (number < 1e3) return number
  if (number >= 1e3 && number < 1e6) return `${+(number / 1e3).toFixed(precision)}${abbreviations[0]}`
  if (number >= 1e6 && number < 1e9) return `${+(number / 1e6).toFixed(precision)}${abbreviations[1]}`
  if (number >= 1e9 && number < 1e12) return `${+(number / 1e9).toFixed(precision)}${abbreviations[2]}`
  return `${+(number / 1e12).toFixed(precision)}${abbreviations[3]}`
}

export const formatNumber = (number: string | number, locale = "en-US") => {
  const options = { maximumSignificantDigits: 21, maximumFractionDigits: 21 }
  if (typeof number === "string") {
    const parsed = Number.parseFloat(number || "0")
    return (Number.isNaN(parsed) ? 0 : parsed).toLocaleString(locale, options)
  }

  return number.toLocaleString(locale, options)
}
